import { BaseApi } from 'api/base.api'

// Interface
import {
  IAboutUsMissionApi,
  IAboutUsMissionApiRequest,
  IAboutUsMissionApiGetAllAttrs,
  IAboutUsMissionApiGetAllResponse,
  IAboutUsMissionApiGetAttrs,
  IAboutUsMissionApiGetResponse,
  IAboutUsMissionApiSaveAttrs,
  IAboutUsMissionApiSaveResponse,
} from 'interfaces/back-office/content-management/about-us/mission/about-us-mission-api.interface'
import { IBaseApiRequestPayload } from 'interfaces/api'

// Constant
import { ApiConstant } from 'constant'

// Utils
import { axios_renderUrl } from 'utils'

export class AboutUsMissionApi extends BaseApi<IAboutUsMissionApi> implements IAboutUsMissionApiRequest {
  readonly url = ApiConstant.CONTENT_ABOUT_US_MISSION_URL
  private aboutUsMissionUrl = axios_renderUrl(this.url, ApiConstant.BACK_OFFICE)

  /**
   * @description Get home banners
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IAboutUsMissionApiGetAllAttrs} payload
   *
   * @return {Promise<IAboutUsMissionApiGetAllResponse>} Promise<IAboutUsMissionApiGetAllResponse>
   */
  async aboutUsMission_getAboutUsMissions(payload: IAboutUsMissionApiGetAllAttrs): Promise<IAboutUsMissionApiGetAllResponse> {
    try {
      const response = await this.POST(`${this.aboutUsMissionUrl}/list`, payload.body, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  /**
   * @description Get home banner
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IAboutUsMissionApiGetAttrs} payload
   *
   * @return {Promise<IAboutUsMissionApiGetResponse>} Promise<IAboutUsMissionApiGetResponse>
   */
  async aboutUsMission_getAboutUsMission(payload: IAboutUsMissionApiGetAttrs): Promise<IAboutUsMissionApiGetResponse> {
    try {
      const response = await this.POST(`${this.aboutUsMissionUrl}/${payload.params.id}`, {}, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  /**
   * @description Save home banner
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IAboutUsMissionApiSaveAttrs} payload
   *
   * @return {Promise<IAboutUsMissionApiSaveResponse>} Promise<IAboutUsMissionApiSaveResponse>
   */
  async aboutUsMission_saveAboutUsMission(payload: IAboutUsMissionApiSaveAttrs): Promise<IAboutUsMissionApiSaveResponse> {
    try {
      const requestPayload: IBaseApiRequestPayload = {
        method: 'POST',
        url: payload.params?.id ? `${this.aboutUsMissionUrl}/update/${payload.params.id}` : `${this.aboutUsMissionUrl}/create`,
      }
      const response = await this[requestPayload.method](requestPayload.url, payload.body, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }
}
